import React, { useState, useEffect } from 'react';
import styles from './Media.module.css';

const Media = () => {
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);  // images for the main gallery
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_CMS_BASE_URL}/api/events`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!data.success) {
          throw new Error('API request was not successful');
        }

        const transformedData = data.news_event_data.map((event) => ({
          id: event.id,
          image: `${process.env.REACT_APP_CMS_BASE_URL}/attachments/${event.thumbnail}`,
          title: event.title,
          subtitle: event.subtitle || `Learn more about ${event.title}`,
          date: event.date || 'Event Date',
          slug: event.slug
        }));

        setMediaData(transformedData);
        // Automatically load first event's gallery
        if (transformedData.length > 0) {
          fetchImagesBySlug(transformedData[0].slug);
        }

        setError(null);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);
  const fetchImagesBySlug = async (slug) => {
    try {
      setLoading(true);
      setCurrentIndex(0); // Reset slider index to first image
      const response = await fetch(`${process.env.REACT_APP_CMS_BASE_URL}/api/events?slug=${slug}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (!data.success) {
        throw new Error('API request was not successful');
      }
      const eventData = data.news_event_data;

      // Set selected event
      setSelectedEvent({
        title: eventData.title,
        subtitle: eventData.description, // use description as subtitle
        date: eventData.date,
        slug: eventData.slug
      });

      // data.news_event_data is a single object with gallery
      const gallery = data.news_event_data.gallery.map((item) => ({
        id: item.id,
        image: `${process.env.REACT_APP_CMS_BASE_URL}/attachments/${item.file}`,
        type: item.file_type
      }));
      setGalleryImages(gallery);
    } catch (err) {
      console.error('Error fetching gallery images:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  if (loading) return <p>Loading events...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!mediaData.length) return <p>No events found.</p>;

  return (
    <div className={styles.mediaWrapper}>
      <div className={styles.imageContainer}>
        <button className={`${styles.navButton} ${styles.navLeft}`} onClick={handlePrev}>‹</button>
  
        {galleryImages.length > 0 && galleryImages[currentIndex] && (
          galleryImages[currentIndex].type === 'image' ? (
            <img
              src={galleryImages[currentIndex].image}
              alt=""
              className={styles.mediaImage}
            />
          ) : (
            <video autoPlay muted  loop  playsInline  controls className={styles.mediaImage}>
              <source src={galleryImages[currentIndex].image} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )
          )}
          {selectedEvent && (
            <div className={styles.spotlightOverlay}>
              <div className={styles.spotlightContent}>
                <p className={styles.spotlightDate}>{selectedEvent.date}</p>
                <h1 className={styles.spotlightTitle}>{selectedEvent.title}</h1>
                <p className={styles.spotlightSubtitle}>{selectedEvent.subtitle}</p>
                <div className={styles.dotsContainer}>
                  {galleryImages.map((_, idx) => (
                    <button
                      key={idx}
                      className={`${styles.dot} ${idx === currentIndex ? styles.activeDot : ''}`}
                      onClick={() => setCurrentIndex(idx)}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        <button className={`${styles.navButton} ${styles.navRight}`} onClick={handleNext}>›</button>
        
      </div>
        {/* <div className={styles.dotsContainer}>
          {galleryImages.map((_, idx) => (
            <button
              key={idx}
              className={`${styles.dot} ${idx === currentIndex ? styles.activeDot : ''}`}
              onClick={() => setCurrentIndex(idx)}
            />
          ))}
        </div> */}
      <div className={styles.thumbnailsContainer}>
        {mediaData.map((item, idx) => (
          <div
            key={item.id}
            className={`${styles.thumbnail}`}
            onClick={() => fetchImagesBySlug(item.slug)}
          >
            <img src={item.image} alt={item.title} className={styles.thumbnailImage} />
            <div className={styles.thumbnailOverlay}>
              <span className={styles.thumbnailTitle}>{item.title}</span>
            </div>
          </div>
          
        ))}
      </div>
      
    </div>
  );
};

export default Media;